import { render } from "./PraticalInformationsView.vue?vue&type=template&id=5da6f447"
import script from "./PraticalInformationsView.vue?vue&type=script&lang=js"
export * from "./PraticalInformationsView.vue?vue&type=script&lang=js"

import "./PraticalInformationsView.vue?vue&type=style&index=0&id=5da6f447&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__